// extracted by mini-css-extract-plugin
export var label = "_br-1";
export var reminder = "_br-0";